import { combineReducers } from "redux";
import * as types from "./types";
import { createReducer } from "../../utils";

const listReducer = createReducer([])({
  
    [types.UPDATE_MY_DETAILS_COMPLETED]: (state, action) => {
        const myDetails = action.payload.payload
        return state.map(e => e.id === myDetails.id ? myDetails : e)
    },
    
});

export default combineReducers({
    list: listReducer
});